const routes = {
    Features: 'features',
    Marketplace: 'marketplace',
    Team: 'team',
    Contact: 'contact',
};
  
export default routes;  